import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ChevronDown } from "lucide-react";

const HeroSection = () => {
  const handleScrollClick = () => {
    const target = document.getElementById("learn-more");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <section className="fixed inset-0 flex items-center justify-center pt-16 z-10 pointer-events-none">
        <div className="container text-center max-w-4xl mx-0 px-[24px] pointer-events-auto">
          <h1 className="text-4xl md:text-5xl lg:text-7xl tracking-tight mb-6 leading-tight font-light text-center drop-shadow-lg" style={{ color: '#13161B' }}>
            RemoteViz helps you strengthen your intuition through remote viewing.
          </h1>
          <p className="text-base md:text-lg lg:text-xl mb-10 max-w-3xl mx-auto leading-relaxed" style={{ color: '#13161B' }}>
            Run structured sessions, capture impressions first, then reveal the target for feedback. 
            Whether you're brand new or experienced, RemoteViz keeps it simple and repeatable.
          </p>
          <Link to="/auth/signup">
            <Button size="lg" className="h-14 px-8 text-lg gap-2 group text-center shadow-lg">
              Start a Remote Viewing Session
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </section>
      {/* Scroll indicator positioned at bottom of viewport - separate fixed element */}
      <button
        type="button"
        onClick={handleScrollClick}
        aria-label="Scroll to learn more"
        className="scroll-indicator fixed bottom-8 left-0 right-0 z-10 flex justify-center pointer-events-auto"
      >
        <ChevronDown className="w-8 h-8 text-primary" />
      </button>
    </>
  );
};
export default HeroSection;